import React, { useEffect } from 'react';

import { store } from 'redux/store';
import { setCurrentTab } from 'redux/reducers/fluxAutomaticLayoutReducer';
import { possibleMltOptions } from 'redux/reducers/fluxAutomaticControlPanelReducer';
import RevisionDesktop from 'components/Flux/Automatic/Revision/Desktop';
import RevisionMobile from 'components/Flux/Automatic/Revision/Mobile';
import useFluxAutomaticFilterSelector from 'utils/hooks/flux/automatic/filterSelector';
import useIsMobile from 'utils/hooks/useIsMobile';

import './index.scss';

export default function Revision() {
  const isMobile = useIsMobile();
  const { setMltOption } = useFluxAutomaticFilterSelector();

  useEffect(() => {
    store.dispatch(setCurrentTab('revision'));
    setMltOption(possibleMltOptions[0]); // %MLT
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isMobile) {
    return <RevisionMobile />;
  }

  return <RevisionDesktop />;
}
